module.exports = __webpack_public_path__ + "static/media/oberflex-cheneteintechenedesmarais-1200x2490.da43ad93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneteintechenedesmarais-1200x2490.jpg
// module id = 1000
// module chunks = 37